export default __webpack_public_path__ + "static/media/mz.1c6eabac.svg";